// StatusSelector.tsx

import React, { useRef } from 'react';
import { OverlayPanel } from 'primereact/overlaypanel';
import StatusBadgeAtom, { StatusValue } from '../../atoms/status-badge/StatusBadgeAtom';
import StatusPopoverMolecule from '../Atlas/StatusPopover/StatusPopoverMolecule';
import type { SphereStatusPoint } from 'types/global';

interface StatusSelectorProps {
  status?: StatusValue;
  sphereId?: string;
  sphereName?: string;
  schemaType?: string;
  statusPoint?: SphereStatusPoint;
  className?: string;
  onStatusDeployed?: () => void;
  /** Callback when user wants to configure status factors - opens SphereEditor to Status Factors tab */
  onConfigureFactors?: (sphereId: string) => void;
}

const StatusSelector: React.FC<StatusSelectorProps> = ({
  status = 'unknown',
  sphereId = '',
  sphereName = '',
  schemaType,
  statusPoint,
  className = '',
  onStatusDeployed,
  onConfigureFactors,
}) => {
  const popoverRef = useRef<OverlayPanel>(null);

  const handleClick = (e: React.MouseEvent) => {
    // Trigger ripple effect
    const target = e.currentTarget as HTMLElement;
    const button = target.closest('.nav-bar-button');
    if (button) {
      button.classList.add('ripple-active');
      setTimeout(() => button.classList.remove('ripple-active'), 600);
    }

    console.log('[StatusSelector] handleClick', { sphereId, sphereName, schemaType, hasStatusPoint: !!statusPoint });
    popoverRef.current?.toggle(e);
  };

  return (
    <div className={className}>
      <button
        type="button"
        onClick={handleClick}
        style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
        aria-label="View status details"
      >
        <StatusBadgeAtom status={status} size={24} />
      </button>
      <StatusPopoverMolecule
        ref={popoverRef}
        sphereId={sphereId}
        sphereName={sphereName}
        schemaType={schemaType}
        status={statusPoint}
        onStatusDeployed={onStatusDeployed}
        onConfigureFactors={onConfigureFactors}
      />
    </div>
  );
};

export default StatusSelector;
